<ul class="navbar-nav float-left mr-auto">
    <li class="nav-item d-none d-lg-block">
        <a (click)="toggleSidebar.emit()" class="nav-link sidebartoggler waves-effect waves-light"
            href="javascript:void(0)">
            <i class="ti-menu" [style.color]="LightenColor(environment.navbarbg ?? '#FFFFFF')"></i>
        </a>
    </li>
</ul>
<ul class="navbar-nav float-right" *ngIf="environment['style'] == 'Marketplace'">




  <li *ngFor="let headerAction of environment['headerActions'] ?? []" class="d-flex justify-content-between align-items-center m-3" (click)="HeaderActionClick(headerAction)">
    <a href="javascript:void(0)" class="link">
      <span *ngIf="headerAction.label">{{headerAction.label}}</span>
      <div class="icon" *ngIf="headerAction.icon">
        <i *ngIf="headerAction.icon" [class]="headerAction.icon"></i>
      </div>
    </a>
  </li>

  <li class="d-flex justify-content-between align-items-center mt-2 " >
    <button class="t-btn cart-wrap" id="cartBtn" style="transition:opacity .2s;" (click)="RichiesteClick()">
      <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"></path><path d="M16 10a4 4 0 01-8 0"></path></svg>
      Richieste
      <span class="cart-dot " [ngClass]="{'h': !RichiesteCount}" id="cdot">{{RichiesteCount}}</span>
    </button>
  </li>
  <li class="d-flex justify-content-between align-items-center mt-2 " >
    <button class="t-btn cart-wrap" id="cartBtn" style="transition:opacity .2s;"  (click)="CarrelloClick()">
      <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"></path><path d="M16 10a4 4 0 01-8 0"></path></svg>
      Carrello
      <span class="cart-dot" [ngClass]="{'h': !getCarrelloCount()}" id="cdot">{{getCarrelloCount()}}</span>
    </button>
  </li>
  <li class="d-flex justify-content-between align-items-center mt-2 " >
    <button class="t-btn cart-wrap" id="cartBtn" style="transition:opacity .2s;" (click)="openNotifiche = !openNotifiche"  >
      <i class="mdi mdi-bell-outline font-weight-bold "></i>
      Notifiche
      <span class="cart-dot" [ngClass]="{'h': false}" id="cdot">{{10}}</span>
    </button>
    <div  class="dropdown-menu dropdown-menu-right show mailbox" *ngIf="openNotifiche" aria-labelledby="navbarDropdown2" >
      <ul class="list-style-none">
        <li class="border-bottom">
          <div class="drop-title bg-info text-white"><h5 class="message-title">Hai {{notifiche.length}} {{notifiche && notifiche?.length > 1 ? "notifiche" : "notifica"}}
          </h5></div>
        </li>
        <li>
          <div  class="message-center message-body" style="height: auto;  overflow: auto;" [perfectScrollbar]="config" *ngFor="let notifica of notifiche">
            <a  class="message-item" (click)="notifica.onClick(notifica)">
                        <span class="btn btn-circle btn-success" style="padding: 0">
                            <i class="mdi mdi-bell-outline font-24"></i>
                        </span>
              <span class="mail-contnet">
                            <h5 class="message-title">{{notifica.value}}</h5>
                        </span>
            </a>
          </div>
        </li>
        <!-- <li>
            <a class="nav-link text-center text-dark link" href="/scadenzario/scadenzario"
                *ngIf="notifiche ">
                <b>Vai al Calendario </b>
                <i class="fa fa-angle-right"></i>
            </a>
        </li> -->
      </ul>
    </div>

  </li>

  <li class="d-flex justify-content-between align-items-center mt-2 ">
    <button class="t-btn t-btn-user" id="accountBtn" (click)="Profilo()">
      <span class="t-user-avatar"> <i-feather style="stroke: #FFFFFF" name="user" class="align-items-center feather-lg"></i-feather></span>
      <span class="t-user-name">{{authenticationService?.currentUserValue?.fullName}}</span>
    </button>
</li>
    <li class="d-flex justify-content-between align-items-center mt-2" >
      <button class="t-btn" (click)="LogOut()" >
        <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
      </button>
    </li>




</ul>
<ul class="navbar-nav float-right" *ngIf="environment['style'] != 'FortyFix' && environment['style'] != 'Marketplace'">
  <li class="nav-item dropdown" ngbDropdown placement="bottom-right">
    <a ngbDropdownToggle class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown"
       role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <i class="flag-icon flag-icon-{{selectedLanguage.icon}}"></i>
    </a>
    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown" ngbDropdownMenu>
            <span class="dropdown-item" href="#" *ngFor="let lang of languages" (click)="changeLanguage(lang)">
                <i class="flag-icon flag-icon-{{lang.icon}}"></i>
                <span>{{lang.language}}
                  <span *ngIf="lang.type">({{lang.type}})</span>
                </span>
            </span>
    </div>
  </li>
  <li *ngIf="!fullScreen" class="d-flex justify-content-between align-items-center m-3" (click)="toggleFullScreen()">
    <div class="icon">
      <i class="fa fa-window-maximize" aria-hidden="true" style="font-size: 1.4rem;"></i>
    </div>
  </li>
  <app-notifications-badge></app-notifications-badge>
  <app-user-dropdown></app-user-dropdown>

</ul>


<ul class="navbar-nav float-right" *ngIf="environment['style'] == 'FortyFix'">

  <li class="nav-item dropdown" ngbDropdown placement="bottom-right" *ngIf="!environment['availableLang'] || environment['availableLang'].length > 1">
    <a ngbDropdownToggle class="nav-link dropdown-toggle" href="javascript:void(0)" id="navbarDropdown2"
       role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <i class="flag-icon flag-icon-{{selectedLanguage.icon}}"></i>
    </a>
    <div  class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown2" ngbDropdownMenu>
            <span class="dropdown-item" href="#" *ngFor="let lang of languages" (click)="changeLanguage(lang)">
                <i class="flag-icon flag-icon-{{lang.icon}}"></i>
                <span>{{lang.language}}
                  <span *ngIf="lang.type">({{lang.type}})</span>
                </span>
            </span>
    </div>
  </li>
  <li class="d-flex justify-content-between align-items-center m-3" ngbDropdown *ngIf="environment['chatApiUrl'] && (permission.HasCapacity(['menu-chat']))">
    <div ngbDropdownToggle class="icon position-relative">
      <i-feather style="stroke: var(--main-color)" name="message-circle" class="align-items-center feather-lg"></i-feather>
      <div class="notify" *ngIf="Messaggi?.length"> <span class="heartbit"></span> <span class="point"></span> </div>
    </div>

    <div class="dropdown-menu dropdown-menu-right mailbox" aria-labelledby="2" style="z-index: 101" ngbDropdownMenu>
      <ul class="list-style-none">
        <li class="border-bottom">
          <div class="drop-title bg-info text-white">Messaggi</div>
        </li>
        <li>
          <div class="message-center message-body" [perfectScrollbar]="config">
            <!-- Message -->
            <a href="/chat/messages/entry" class="message-item">
              <span class="btn btn-circle btn-success" style="padding: 0">
                <i class="far fa-bell font-24"></i>
              </span>
              <span class="mail-contnet">
                <h5 class="message-title">Hai&nbsp;{{Messaggi?.length ? Messaggi.length : 0}}&nbsp;{{Messaggi?.length == 1
                  ? "Messaggio non letto" : "Messaggi non letti"}}</h5>
              </span>
            </a>
          </div>
        </li>
        <li>
          <a class="nav-link text-center text-dark link" href="/chat/messages/entry" *ngIf="Messaggi?.length ">
            <b>Vai alla Chat </b>
            <i class="fa fa-angle-right"></i>
          </a>
        </li>
      </ul>
    </div>
  </li>
  <li *ngIf="!fullScreen" class="d-flex justify-content-between align-items-center m-3" (click)="toggleFullScreen()">
    <div class="icon">
      <i-feather *ngIf="!fullScreen" style="stroke: var(--main-color)" name="maximize" class="align-items-center feather-lg"></i-feather>
      <i-feather *ngIf="fullScreen" style="stroke: var(--main-color)" name="minimize" class="align-items-center feather-lg"></i-feather>
    </div>
  </li>
    <li *ngFor="let headerAction of environment['headerActions'] ?? []" class="d-flex justify-content-between align-items-center m-3" (click)="HeaderActionClick(headerAction)">
      <a href="javascript:void(0)" class="link">
      <span *ngIf="headerAction.label">{{headerAction.label}}</span>
      <div class="icon" *ngIf="headerAction.icon">
        <i *ngIf="headerAction.icon" [class]="headerAction.icon"></i>
      </div>
      </a>
    </li>

  <li class="d-flex justify-content-between align-items-center m-3">

    <div class="icon">
      <i-feather style="stroke: var(--main-color)" name="bell" class="align-items-center feather-lg"></i-feather>
    </div>
  </li>
  <li class="ciao-utente d-flex justify-content-between align-items-center m-3" (click)="Profilo()">
      <div class="icon"  >
        <i-feather style="stroke: var(--main-color)" name="user" class="align-items-center feather-lg"></i-feather>
      </div>
      <span style="color: #666666">Ciao {{authenticationService?.currentUserValue?.fullName}}!</span>
  </li>
  <li class="logout-button d-flex justify-content-between align-items-center" (click)="LogOut()">
    <span style="color: var(--main-color)">Logout</span>
  </li>


</ul>




